import { render, staticRenderFns } from "./QuotaProfileModal.vue?vue&type=template&id=d66fbf2a&scoped=true"
import script from "./QuotaProfileModal.vue?vue&type=script&lang=js"
export * from "./QuotaProfileModal.vue?vue&type=script&lang=js"
import style0 from "./QuotaProfileModal.vue?vue&type=style&index=0&id=d66fbf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66fbf2a",
  null
  
)

export default component.exports